export default {
  reset: '重置',
  pleaseScan: '请扫描 ',
  blurTip: '请将光标移动到UPC输入框',
  connectError: '无法连接到NFC设备，请重启设备后并刷新页面',
  multipleNfcError: '读取到多个NFC，请重新扫描',
  uidEmptyError: 'NFC Uid不能为空',
  uidExistsError: 'NFC已被绑定',
  upcEmptyError: 'UPC不能为空',
  skuNotExistError: '产品在列表中不存在，请联系管理员',
  nfcHasBoundError: 'NFC已经绑定',
  illegalUpcError: '非法UPC',
  macError: '未能识别到中间件，若需要绑定，请启动所有中间件并确保平板已启动后重新登录',
  workstationError: '未能识别到工作台，若需要绑定，请联系管理员后重新登录',
  backText: '返回上一页',
  loginText: '重新登陆',
  tagType: 'SKU需要绑定类型',
  NFCUIDInvalid: '无效的 NFC UID',
  NFCUIDDisabled: 'NFC UID已被注销',
  tagTypeNotMatch: '产品应该绑定类型',
  nddcTagTypeNotMatch: '应该绑定类型',
  requiredTagType: '预期的标签类型:',
  actualTagType: '实际的标签类型:',
  rfMacError: '未能识别到中间件，请打开桌面上的“Nike T-hub”小程序并启用服务后进行重新登录',
  tagTypeError: '未获取到标签类型，请重新尝试'
}
